export default `# 【可接入】资金方通用解决方案

# 大搜车开放平台接入


## 快速开始

### 接入流程

1. 申请成为大搜车开放平台合作商，获取 appKey 和 appSecret
1. 申请需要用到服务的权限
1. 参考认证鉴权方式对每个请求进行签名，使用签名请求大搜车开放平台服务
# 业务交互时序
> 主要阅读 资金方、开放平台、资产管理系统 三方 交互即可

![image.png](https://cdn.nlark.com/yuque/18/2019/png/132987/1558342564862-1a4f8a0b-612a-4f99-af38-dfcc784d670b.png#align=left&display=inline&height=952&name=image.png&originHeight=952&originWidth=763&size=85420&status=done&width=763)



<a name="818f56bd"></a>
# 大搜车开放平台接入

<a name="c182e73c"></a>
## 快速开始
<a name="a30527ed"></a>
### 接入流程

1. 申请成为大搜车开放平台合作商，获取 appKey 和 appSecret
1. 申请需要用到服务的权限
1. 参考认证鉴权方式对每个请求进行签名，使用签名请求大搜车开放平台服务

<a name="bfbd6114"></a>
### 接口说明

- 接口需要认证，具体方式参考下一节 <code>认证鉴权</code>
- 接口接收与响应参数均为 JSON 格式
- 接口接收与响应字符集均为 UTF-8
- 接口只有一个请求地址，HTTP method 为 POST，请求的具体 API 与参数放在 HTTP body 中

<a name="251b56d4"></a>
### 请求地址

- 测试环境：POST [http://openapi.proxy.dasouche.com/v3](http://openapi.proxy.dasouche.com/v3)
- 预发环境：POST [http://openapi.prepub.souche.com/v3](http://openapi.prepub.souche.com/v3)
- 线上环境：POST [https://openapi.souche.com/v3](https://openapi.souche.com/v3)

<a name="527466ff"></a>
### 请求参数

- api: <code>JSON String</code> 具体 API 名称
- appKey: <code>JSON String</code> 咲夜开放平台生成的账户 appKey
- timestamp: <code>JSON Number</code> 秒级别时间戳
- data: <code>JSON Object String</code> 具体 API 要求的输入参数
- sign: <code>JSON Strig</code> 签名，具体方式参考认证鉴权
<a name="aa6070a7"></a>
### 响应数据
<pre>
{
      "code": 0,
      "status": 200,
      "message": "success",
      "data": {
          "name": "Tom",
          "gender": 1,
          "avatar": "http://picture.com/users/xv1fg4h"
      }
 }
 </pre>
 #### 请求 curl 代码
<pre>
curl -X POST \
    http://api.proxy.dasouche.com/v3 \
    -H 'content-type: application/json' \
    -d '{
      "api": "com.souche.shield.service#getUserById",
      "appKey": "ad33d1190ff8383b5650097c0b6403868a82bd4c",
      "timestamp": 1528420183,
      "data": "{\"id\":\"xv1fg4h\"}",
      "sign": "9b94171630348afdb950b8c26edeec608e0c1f78"
  }'
</pre>


<a name="6c2fd242"></a>
## 认证鉴权
<a name="33dbf23a"></a>
#### 签名方式

1. 将请求体中的参数除去 sign 字段外按照字典序排序，按照 <code>key1=value1&key2=value2</code> 的格式拼接成字符串
1. 将拼接后的字符串进行 base64 编码
1. 将 base64 编码后的字符串前拼接上 <code>appSecret:</code>
1. 将拼接后的字符串进行 sha1 加密得到 sign 值
<a name="d88ed8f5"></a>
#### 签名示例
<code>com.souche.shield.service#getUserById（根据用户 ID 获取用户信息）</code><br />API 参数文档

| 字段 | 类型 | 是否必须 | 含义 | 备注 |
| --- | --- | --- | --- | --- |
| id | String | ✔️ | 用户 ID |  |

请求数据
<pre>
{
    "api": "com.souche.shield.service#getUserById",
    "appKey": "ad33d1190ff8383b5650097c0b6403868a82bd4c",
    "timestamp": 1528420183,
    "data": "{\"id\":\"xv1fg4h\"}",
    "sign": "9b94171630348afdb950b8c26edeec608e0c1f78"
}
</pre>

1. 请求体参数排序并拼接字符串<br />
<pre>api=com.souche.shield.service#getUserById&appKey=ad33d1190ff8383b5650097c0b6403868a82bd4c&data={"id":"xv1fg4h"}&timestamp=1528420183</pre>

1. 将拼接后的字符串进行 base64 编码<br />
<pre>YXBpPWNvbS5zb3VjaGUuc2hpZWxkLnNlcnZpY2UjZ2V0VXNlckJ5SWQmYXBwS2V5PWFkMzNkMTE5MGZmODM4M2I1NjUwMDk3YzBiNjQwMzg2OGE4MmJkNGMmZGF0YT17ImlkIjoieHYxZmc0aCJ9JnRpbWVzdGFtcD0xNTI4NDIwMTgz</pre>

1. 将 base64 编码后的字符串前拼接上 <code>appSecret:</code>
<pre>569f4f8050a4bfc87ebfaf1e0b4d71aae58f3958:YXBpPWNvbS5zb3VjaGUuc2hpZWxkLnNlcnZpY2UjZ2V0VXNlckJ5SWQmYXBwS2V5PWFkMzNkMTE5MGZmODM4M2I1NjUwMDk3YzBiNjQwMzg2OGE4MmJkNGMmZGF0YT17ImlkIjoieHYxZmc0aCJ9JnRpbWVzdGFtcD0xNTI4NDIwMTgz</pre>

1. 将拼接后的字符串进行 sha1 加密的到 sign 值<br />
<pre>9b94171630348afdb950b8c26edeec608e0c1f78</pre>


<a name="1ce4e075"></a>
## 错误码表
| HTTP 状态码 | API 错误码 | 含义 |
| --- | --- | --- |
| 400 | 40000001 | 业务内部错误 |
| 401 | 40100001 | 缺少 sign 或 token |
| 401 | 40100002 | 缺少 appKey |
| 401 | 40100003 | 缺少 timestamp |
| 401 | 40100004 | 非开放平台合作用户 |
| 401 | 40100005 | sign 过期 |
| 401 | 40100006 | sign 不合法 |
| 401 | 40100007 | token 过期 |
| 401 | 40100008 | token 不合法 |
| 403 | 40300001 | 请求 IP 不在预设 IP 白名单内 |
| 403 | 40300002 | 没有此 API 调用权限 |
| 403 | 40300003 | 没有业务权限 |
| 500 | 50000001 | 开放平台内部错误 |

<a name="7d3a5003"></a>
# 
<a name="dWOIy"></a>
# 接口约定
<a name="4cf24aba"></a>
### 金额
金额单位统一用元, 精确到分. 例如 1000.00

<a name="4ff1e74e"></a>
### 日期
日期格式 yyyy-MM-dd, 或者 yyyy-MM-dd HH:mm:ss, 具体看字段说明. 示例 2019-01-31 12:23:12

<a name="8dbec4f0"></a>
### JSON格式

- key存在而值不存在时, key 仍然会传, 值对应 null. 示例 {"name":null}
- 空数组传 [] 而不是 null. 示例 {"emptyList":[]}
<a name="XdQhI"></a>
# 
<a name="mjnYW"></a>
# 接口列表
> 具体接口名称 以实际为准


<a name="7b15c1c5"></a>
## 大搜车提供的接口
详细接口文档 见 [http://opendocs.proxy.dasouche.com/docs/100000526?groupId=100000078](http://opendocs.proxy.dasouche.com/docs/100000526?groupId=100000078)
<a name="3e33f05d"></a>
### 1. 审核接口
<a name="6c72079f"></a>
### 2. 查询附件接口
<a name="c9b52d6a"></a>
### 3. 募集接口
<a name="3ef90539"></a>
### 4. 资产字段
<a name="d41d8cd9-2"></a>
## 
<a name="48d8bffb"></a>
## 资金方需要实现的鉴权
鉴权部分文档 见 [https://souche.yuque.com/docs/share/65a25181-ed79-4e30-a039-4de9698f1770](https://souche.yuque.com/docs/share/65a25181-ed79-4e30-a039-4de9698f1770)<br />具体可咨询 许波 [@maple(u1100)](/u1100) 

<a name="0f78ef6c"></a>
## 资金方需要实现的接口

<a name="69050582"></a>
### 1. 资产包地址推送接口

<a name="bfbd6114-1"></a>
#### 接口说明
| 项目 | 说明 |
| --- | --- |
| API | com.funds.carloan.service#file |
| 交易名称 | 资产包地址推送接口 |
| 功能描述 | 推送资产包下载地址 |
| 应用功能 | 大搜车方通过此接口，推送资产包的下载地址，资金方信托自行下载资产包 |
| 请求方 | 大搜车 |
| 应答方 | 资金方 |

<a name="21f2fa80"></a>
#### 参数说明
| 字段 | 类型 | 必填 | 说明 | 备注 |
| --- | --- | --- | --- | --- |
| batchNo | String | Y | 交易批次号 | 每次推送资产包的唯一编号 |
| trustProductNo | String | Y | 信托计划号 |  |
| downloadUrl | String | Y | 资产包下载地址 |  |
| applyDate | String |  | 资产包申请日期 | 格式 yyyy-MM-dd |

<a name="3279c3a4"></a>
### 2. 还款信息同步接口

<a name="bfbd6114-2"></a>
#### 接口说明
| 项目 | 说明 |
| --- | --- |
| API | com.funds.carloan.service#repaymentInfo |
| 交易名称 | 还款信息同步接口 |
| 功能描述 | 同步资产还款信息 |
| 应用功能 | 大搜车通过此接口发送还款信息，资金方同步还款信息 |
| 请求方 | 大搜车 |
| 应答方 | 资金方 |

<a name="21f2fa80-1"></a>
#### 参数说明
| 字段 | 类型 | 必填 | 说明 | 备注 |
| --- | --- | --- | --- | --- |
| tradeFlowNo | String | Y | 订单号 | 推送资产的单笔订单号 |
| perdNo | Number | Y | 还款期数 | 还款所属期数 |
| repayAmount | String | Y | 还款金额 |  |
| bankFlowNo | String | N | 银行流水号 |  |
| calDate | String | Y | 还款日期 | yyyy-MM-dd |
| overdueDays | Number | N | 实际逾期天数 |  |
| penaltyAmouNumb | Number | N | 实际还款金额的罚息 | <br /> |
| advanceAmoNumb | Number | N | 实际垫付金额 |  |
| payChannel | String | Y | 支付渠道 |  |

<a name="7df7297a"></a>
### 3. 保证金扣收同步接口

<a name="bfbd6114-3"></a>
#### 接口说明
| 项目 | 说明 |
| --- | --- |
| API | com.funds.carloan.service#depositInfo |
| 交易名称 | 保证金扣收同步接口 |
| 功能描述 | 同步保证金扣收信息 |
| 应用功能 | 大搜车通过此接口发送保证金扣收信息，资金方同步扣收信息 |
| 请求方 | 大搜车 |
| 应答方 | 资金方 |

<a name="21f2fa80-2"></a>
#### 参数说明
| 字段 | 类型 | 必填 | 说明 | 备注 |
| --- | --- | --- | --- | --- |
| reqFlowNo | String | Y | 扣收流水号 | 每笔唯一 |
| tradeFlowNo | String | Y | 订单号 | 推送资产的单笔订单号 |
| drawAmount | Number | Y | 扣收金额 | 单位元, 精确到分 |
| drawType | String | Y | 扣收类型 | OVER_MILEAGE: 超里程，<br />BREAK_RULES: 违章，<br />INSURANCE_DEPOSIT: 出 险，OTHER_DEPOSIT: 其他 |
| calTime | String | Y | 时间 | 扣收日期，yyyy-MM-dd<br />HH:mm:ss |
`


